import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import {
  termsFormDataDefault,
  termsFormDataSchema,
} from '~/components/NegotiationTermsForm/NegotiationTermsForm.schema';
import {
  supplierContactFormDataDefault,
  supplierContactFormDataSchema,
} from '~/modules/NegotiationSupplierContactWidget/components/SupplierContactForm/SupplierContactForm.schema';

// Repeated refine because zod doesn't allow merging of ZodEffect objects
export const negotiationCaseCreateFormDataSchema = supplierContactFormDataSchema.merge(termsFormDataSchema);

export type NegotiationCaseCreateFormData = z.infer<typeof negotiationCaseCreateFormDataSchema>;

export const negotiationCaseCreateFormDataDefault: DefaultValues<NegotiationCaseCreateFormData> = {
  ...supplierContactFormDataDefault,
  ...termsFormDataDefault,
};
